export default __webpack_public_path__ + "static/positive-feedback-f9beb140a3c295c65366d57f4430b7ea.mp3";